"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckoutOfferHints = exports.checkoutOfferHintsContext = exports.CheckoutOfferHintsProvider = void 0;
var _react = require("react");
var _types = require("../types");
const checkoutOfferHintsContext = exports.checkoutOfferHintsContext = /*#__PURE__*/(0, _react.createContext)(_types.DEFAULT_CHECKOUT_OFFER_HINTS_CONTEXT);
const CheckoutOfferHintsProvider = exports.CheckoutOfferHintsProvider = checkoutOfferHintsContext.Provider;
const useCheckoutOfferHints = () => (0, _react.useContext)(checkoutOfferHintsContext);
exports.useCheckoutOfferHints = useCheckoutOfferHints;